"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var formik_1 = require("formik");
var react_datepicker_1 = require("react-datepicker");
var FileInput_1 = require("../../../../common/FileInput");
var EditDebtUploadTermsModal_1 = require("./EditDebtUploadTermsModal");
var EditDebtInvoice = function (props) {
    var _a, _b;
    var showFileInput = props.status === 'reverted' ||
        props.status === 'unsubmitted' ||
        props.debt.status === null ||
        props.file.filename !== '';
    var _c = __read(React.useState(false), 2), modalOpen = _c[0], setModalOpen = _c[1];
    return (React.createElement("div", null,
        React.createElement("div", { className: "form-input full-width" },
            React.createElement("label", { className: "required", htmlFor: "invoice_reference" }, "Invoice number"),
            React.createElement("input", { type: "text", name: "invoice_reference", value: props.values.invoice_reference, onChange: function (e) {
                    var value = e.target.value;
                    props.setFieldTouched('invoice_reference', true, true);
                    props.setFieldValue('invoice_reference', value);
                }, placeholder: "Invoice Ref", disabled: props.disabled })),
        React.createElement(formik_1.ErrorMessage, { name: "invoice_reference" }, function (msg) { return React.createElement("div", { className: "error-feedback edit-debt" }, msg); }),
        React.createElement("div", { className: "form-input full-width" },
            React.createElement("label", { className: "required", htmlFor: "invoice_sent_date" }, "Invoice sent date"),
            React.createElement(formik_1.Field, { disabled: props.disabled, render: function (_a) {
                    var field = _a.field;
                    return (React.createElement(react_datepicker_1.default, __assign({}, field, { selected: Date.parse(props.values.invoice_sent_date), onChange: function (value) {
                            props.setFieldTouched('invoice_sent_date', true, true);
                            props.setFieldValue('invoice_sent_date', value);
                        }, popperPlacement: "top-end", popperModifiers: {
                            offset: {
                                enabled: true,
                                offset: '5px, 10px',
                            },
                            preventOverflow: {
                                enabled: true,
                                escapeWithReference: false,
                                boundariesElement: 'viewport',
                            },
                        }, dateFormat: "dd/MM/yyyy", todayButton: 'Today', maxDate: new Date() })));
                }, name: "invoice_sent_date" })),
        React.createElement(formik_1.ErrorMessage, { name: "invoice_sent_date" }, function (msg) { return React.createElement("div", { className: "error-feedback edit-debt" }, msg); }),
        React.createElement("div", { className: "form-input full-width" },
            React.createElement("label", { className: "required", htmlFor: "invoice_due_date" }, "Invoice due date"),
            React.createElement(formik_1.Field, { disabled: props.disabled, render: function (_a) {
                    var field = _a.field;
                    return (React.createElement(react_datepicker_1.default, __assign({}, field, { selected: Date.parse(props.values.invoice_due_date), onChange: function (value) {
                            props.setFieldTouched('invoice_due_date', true, true);
                            props.setFieldValue('invoice_due_date', value);
                        }, popperPlacement: "top-end", popperModifiers: {
                            offset: {
                                enabled: true,
                                offset: '5px, 10px',
                            },
                            preventOverflow: {
                                enabled: true,
                                escapeWithReference: false,
                                boundariesElement: 'viewport',
                            },
                        }, dateFormat: "dd/MM/yyyy", placeholderText: "Click to select a date", todayButton: 'Today', minDate: new Date(props.values.invoice_sent_date), maxDate: new Date() })));
                }, name: "invoice_due_date" })),
        React.createElement(formik_1.ErrorMessage, { name: "invoice_due_date" }, function (msg) { return React.createElement("div", { className: "error-feedback edit-debt" }, msg); }),
        React.createElement("div", { className: "form-input full-width" },
            React.createElement("label", { htmlFor: "reminder_sent_date" }, "Reminder sent date"),
            React.createElement(formik_1.Field, { disabled: props.disabled, render: function (_a) {
                    var field = _a.field;
                    return (React.createElement(react_datepicker_1.default, __assign({}, field, { selected: Date.parse(props.values.reminder_sent_date), onChange: function (value) { return props.setFieldValue('reminder_sent_date', value); }, popperPlacement: "top-end", popperModifiers: {
                            offset: {
                                enabled: true,
                                offset: '5px, 10px',
                            },
                            preventOverflow: {
                                enabled: true,
                                escapeWithReference: false,
                                boundariesElement: 'viewport',
                            },
                        }, placeholderText: "Click to select a date", dateFormat: "dd/MM/yyyy", todayButton: 'Today', minDate: new Date(props.values.invoice_sent_date), maxDate: new Date() })));
                }, name: "reminder_sent_date" })),
        React.createElement(formik_1.ErrorMessage, { name: "reminder_sent_date" }, function (msg) { return React.createElement("div", { className: "error-feedback edit-debt" }, msg); }),
        showFileInput && (React.createElement(React.Fragment, null,
            React.createElement("label", { className: "edit-debt-invoice-upload-label" },
                "Invoice/Supporting Documents Upload",
                ' ',
                React.createElement("i", { className: "fas fa-question-circle", style: { cursor: 'pointer' }, onClick: function () { return setModalOpen(true); } }),
                React.createElement(EditDebtUploadTermsModal_1.default, { modalOpen: modalOpen, onClose: function () { return setModalOpen(false); } })),
            React.createElement("div", { className: "flex-column" },
                React.createElement(FileInput_1.default, { value: (_b = (_a = props.file) === null || _a === void 0 ? void 0 : _a.filename) !== null && _b !== void 0 ? _b : null, setFileUpload: function (newFile) {
                        props.setFile(newFile);
                        props.setFileUploaded(true);
                    } }))))));
};
exports.default = EditDebtInvoice;
